module.exports = __webpack_public_path__ + "static/media/youtubeBlack.d9a00ecd.svg";